import { Box, IconButton, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import Panel from "../../../components/panels/Panel";

const AddressbookPanelShell = ({
  title,
  titleContent,
  headerActions,
  subHeader,
  footerLeft,
  footerRight,
  onClose,
  scrollResetKey,
  children,
}) => (
  <Panel
    title={title}
    titleContent={titleContent}
    subHeader={subHeader}
    scrollResetKey={scrollResetKey}
    headerActions={
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          "& :where(.MuiIconButton-root[data-shell-muted='true'])": {
            borderRadius: "50%",
            border: "1px solid #E2E8F0",
            backgroundColor: "#F8FAFC",
          },
          "& :where(.MuiIconButton-root[data-shell-muted='true']):hover": {
            backgroundColor: "#EEF2F7",
            borderColor: "#CBD5E1",
          },
        }}
      >
        {headerActions}
        {onClose && (
          <IconButton
            size="small"
            onClick={onClose}
            aria-label="Close panel"
            data-shell-muted="true"
            sx={{ width: 24, height: 24 }}
          >
            <CloseIcon sx={{ fontSize: 14 }} />
          </IconButton>
        )}
      </Box>
    }
    footer={
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, width: "100%" }}>
        <Box sx={{ minWidth: 0 }}>
          {typeof footerLeft === "string" ? (
            <Typography sx={{ color: "text.secondary", fontSize: 11 }}>{footerLeft}</Typography>
          ) : (
            footerLeft
          )}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>{footerRight}</Box>
      </Box>
    }
  >
    {children}
  </Panel>
);

export default AddressbookPanelShell;
